import { PropTypes } from "prop-types"

const Heading = ({ children, cssClassName, ariaLabel, level = 1, ...otherProps }) => {
  const HeadingElement = `h${level}`

  return (
    <HeadingElement className={cssClassName} aria-label={ariaLabel} {...otherProps}>
      {children}
    </HeadingElement>
  )
}

Heading.propTypes = {
  level: PropTypes.oneOf([1, 2, 3, 4, 5, 6]),
  ariaLabel: PropTypes.string,
  cssClassName: PropTypes.string,
  children: PropTypes.node
}

export default Heading
